import { orchestrator } from 'satcheljs';
import { getLockedCalendarEventsStore } from '../selectors/calendarEventsLockedStoreSelectors';
import { loadEventsForDateRange } from '../actions/internalActions';
import { getScenarioActions } from '../actions/getScenarioActions';
import { getScenarioSelectors } from '../selectors/agendaStoreSelectors';
import { trace } from 'owa-trace';
import { isLocalCalendarEntry } from 'owa-calendar-cache';
import { subscribeNotifications } from 'owa-calendar-events-store';

export const loadEventsForDateRangeOrchestrator = orchestrator(
    loadEventsForDateRange,
    async actionMessage => {
        const { dateRange, folderIds, scenarioId } = actionMessage;
        const { updateLoadingInitialData } = getScenarioActions(scenarioId);
        const { getEventLockCacheId } = getScenarioSelectors(scenarioId);
        const lockId = getEventLockCacheId();
        const lockStore = getLockedCalendarEventsStore(lockId);

        updateLoadingInitialData(true);
        try {
            await Promise.all(
                folderIds.map(folderId => {
                    subscribeToNotifications(folderId);
                    lockStore.fetchCalendarEventsForDateRange(folderId, dateRange);
                })
            );
        } catch (error) {
            trace.warn('loadEventsForDateRange: Exception occured: ' + error.message);
        }
        updateLoadingInitialData(false);
    }
);

function subscribeToNotifications(folderId: string) {
    if (isLocalCalendarEntry(folderId)) {
        // TODO-VSO #29078: Subscribe to group calendar notifications if its a group calendar
        subscribeNotifications(folderId);
    }
}
